import React from 'react';

// Huy hiệu cấp clan, dùng ở danh sách clan và bảng xếp hạng quý.
const ClanLevelBadge: React.FC<{ level?: number | null }> = ({ level }) => (
  <span
    data-testid="clan-level-badge"
    className="inline-block shrink-0 rounded-full bg-[#EEF4FF] px-2 py-[1px] text-[11px] font-semibold text-[#066bff] dark:bg-slate-700 dark:text-sky-300"
  >
    Cấp {level && level > 0 ? level : 1}
  </span>
);

export default ClanLevelBadge;
